export default {
    getScheduleActivities: { method: 'get', url: 'schedule_activities' },
    postScheduleActivities: { method: 'post', url: 'schedule_activities' },
    putScheduleActivities: { method: 'put', url: 'schedule_activities/{id}' },
    deleteScheduleActivities: { method: 'delete', url: 'schedule_activities/{id}' },
}
